export default function(allOrganizationsFilter){
  this.setState({ allOrganizationsFilter })
}
